import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatOrderStatus' })
export class OrderStatusFormatPipe implements PipeTransform {
  transform(value: string, searchType = false): string {
    let status: string;
    if (/_27$|_98$/.test(value)) {
      // CLAIM_READY_COMPLETED_VSP_ORDER_27 or COMPLETED_PRIVATE_ORDER_98
      status = 'Lab Shipped';
    } else {
      status = value
        .replace(/_\d+/g, '')
        .replace(/_/g, ' ')
        .replace(/(\w)(\w*)/g, function (g0, g1, g2) {
          return `${g1.toUpperCase()}${g2.toLowerCase()}`;
        });
    }
    if (searchType) {
      return 'In Progress - ' + status;
    }
    return status;
  }
}
